"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var stitches_config_1 = require("../stitches.config");
var StyledText = (0, stitches_config_1.styled)("div", {
    variants: {
        variant: {
            "title-7xl": {
                fontWeight: 600,
                fontSize: 48,
                lineHeight: "56px",
            },
            "title-5xl": {
                fontWeight: 600,
                fontSize: 36,
                lineHeight: "42px",
            },
            "title-3xl": {
                fontWeight: 600,
                fontSize: 32,
                lineHeight: "40px",
            },
            "title-2xl": {
                fontWeight: 600,
                fontSize: 24,
                lineHeight: "30px",
            },
            "title-xl": {
                fontWeight: 600,
                fontSize: 20,
                lineHeight: "26px",
            },
            "title-lg": {
                fontWeight: 600,
                fontSize: 18,
                lineHeight: "24px",
            },
            "title-base": {
                fontWeight: 600,
                fontSize: 16,
                lineHeight: "20px",
            },
            "heading-xl": {
                fontWeight: 500,
                fontSize: 20,
                lineHeight: "26px",
            },
            "heading-lg": {
                fontWeight: 500,
                fontSize: 20,
                lineHeight: "24px",
            },
            "heading-base": {
                fontWeight: 500,
                fontSize: 16,
                lineHeight: "22px",
            },
            "heading-sm": {
                fontWeight: 500,
                fontSize: 14,
                lineHeight: "20px",
            },
            "text-base-plus": {
                fontWeight: 450,
                fontSize: 16,
                lineHeight: "22px",
            },
            "text-base": {
                fontWeight: 400,
                fontSize: 16,
                lineHeight: "22px",
            },
            "text-sm-plus": {
                fontWeight: 450,
                fontSize: 14,
                lineHeight: "20px",
            },
            "text-sm": {
                fontWeight: 400,
                fontSize: 14,
                lineHeight: "20px",
            },
            "text-xs-plus": {
                fontWeight: 450,
                fontSize: 13,
                lineHeight: "18px",
            },
            "text-xs": {
                fontWeight: 400,
                fontSize: 13,
                lineHeight: "18px",
            },
        },
    },
    fontFamily: "Inter",
    defaultVariants: {
        variant: "text-base",
    },
});
var className = "text";
function Text(props) {
    return ((0, jsx_runtime_1.jsx)(StyledText, __assign({}, props, { className: "".concat(className, " ").concat(props.className) }, { children: props.children })));
}
exports.Text = Text;
Text.toString = function () { return ".".concat(className); };
//# sourceMappingURL=Text.js.map